<template>
    <div class="dashboard">
        <h1>検索</h1>
        <div class="l-mb4 l-4-10-b--all">
            <div>
                <p>納入日</p>
                <input v-model="params.date" class="l-mt2" type="date">
            </div>
            <div>
                <p>施工業者</p>
                <input v-model="params.contractor" class="l-mt2" type="text">
            </div>
            <div>
                <p>現場名</p>
                <input v-model="params.name" class="l-mt2" type="text">
            </div>
            <div class="is-left" >
                <button :class="`${classButtonStyle}primary`" class="l-mb1" type="button" @click="historyPush()">検索</button>
            </div>
        </div>
        <table>
            <tr>
                <th>
                    &nbsp;
                </th>
                <th v-for="data in tableSet" :key="data.key" :class="data.class">
                    {{ data.head }}
                </th>
                <th class="is-right">&nbsp;</th>
            </tr>
            <tr v-for="(list, index) in sortingListDeliveryDestinationsFilter" :key="`list${index}`">
                <td>
                    {{ index + 1 }}
                </td>
                <template v-for="data in tableSet">
                    <td v-if="data.key === 'delivery_destination_date'" :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] | changeFormatDeliveryDestinationDate }}
                    </td>
                    <td v-else :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] }}
                    </td>
                </template>
                <td class="is-right">
                    <router-link :class="`${classButtonStyle}primary`" :to="{ name: 'offices_delivery_destinations_recreate', params: { baseId: String(list.id) }}" type="button" tag="button">再登録</router-link>
                    <!-- <button :class="`${classButtonStyle}primary`" type="button" @click="reCreate(list.id)">再登録</button> -->
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";
    import sorts from "@/mixins/sort";

    const tableSearch = [
        {
            "class": "",
            "head": "納入日",
            "key": "delivery_destination_date",
        },
        {
            "class": "is-wrap",
            "head": "施工業者",
            "key": "contractor",
        },
        {
            "class": "is-wrap",
            "head": "現場名",
            "key": "delivery_destination_name",
        },
        {
            "class": "is-right",
            "head": "納入量（㎥）",
            "key": "current_delivery_amount",
        },
    ];

    export default {
        "filters": {
            changeFormatDeliveryDestinationDate(val) {
                // dateの表示形式を変更
                if (typeof val === "string") {
                    return val.replace(/-/g, "/");
                } else {
                    return val;
                }
            },
        },
        "mixins": [
            common,
            sorts,
        ],
        data() {
            return {
                "classButtonStyle": "button--",
                "input": {
                    "delivery_destination_date": "",
                    "contractor": "",
                    "delivery_destination_name": "",
                    "delivery_destination_address": "",
                    "delivery_destination_address_lat": "",
                    "delivery_destination_address_lng": "",
                    "forbidden_time_flag": "",
                    "image_1": "",
                    "image_2": "",
                    "image_3": "",
                },
                "listDeliveryDestinationsFilter": [],
                "params": {
                    "date": "",
                    "contractor": "",
                    "name": "",
                },
                "tableSet": tableSearch,
            };
        },
        "computed": {
            sortingListDeliveryDestinationsFilter() {
                // 納入日で昇順
                const list = this.listDeliveryDestinationsFilter;
                const key = "delivery_destination_date";
                return this.$_sorting(list, key);
            },
        },
        created() {
            if (this.$route.fullPath !== "/offices/delivery_destinations_search/" && this.$route.fullPath !== "/search") {
                this.fetchingDeliveryDestinationsFilter();
            }
        },
        "methods": {
            setDate() {
                // 今日の日付をset
                const today = new Date();
                const year = today.getFullYear();
                const month = ("0" + (today.getMonth() + 1)).slice(-2);
                const date = ("0" + today.getDate()).slice(-2);
                return `${year}-${month}-${date}`;
            },
            getParams() {
                // クエリからパラメータを取得
                for (let key in this.params) {
                    this.params[key] = this.$route.query[key];
                }
            },
            historyPush() {
                // ブラウザ履歴に登録
                this.$router.push({ "name": "offices_delivery_destinations_search", "query": this.params }, () => {}, () => {});
                this.fetchingDeliveryDestinationsFilter();
            },
            reCreate(id) {
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations/${id}`,
                    this.$_requestConfig()
                ).then(response => {
                    this.input = response.data;
                    this.input.delivery_destination_date = this.setDate();
                    let nullFile = new File([""], "", { "type": null });
                    let formData = new FormData();
                    formData.append("image_1", nullFile);
                    formData.append("image_2", nullFile);
                    formData.append("image_3", nullFile);
                    formData.append("data", `{
                        "delivery_destination_date": "${this.input.delivery_destination_date}",
                        "contractor": "${this.input.contractor}",
                        "delivery_destination_name": "${this.input.delivery_destination_name}",
                        "delivery_destination_address": "${this.input.delivery_destination_address}",
                        "delivery_destination_address_lat": "${this.input.delivery_destination_address_lat}",
                        "delivery_destination_address_lng": "${this.input.delivery_destination_address_lng}",
                        "forbidden_time_flag": "${this.input.forbidden_time_flag}",
                    }`);
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/delivery_destinations`,
                        formData,
                        this.$_requestConfig("file")
                    ).then(() => {
                        this.$router.push({ "name": "offices_delivery_allocations_create" });
                    }).catch(() => {
                        this.$_modalError("createDeliveryDestinationsError");
                    });
                }).catch(() => {
                    this.$_modalError("fetchingDeliveryDestinationsError");
                });
            },
            fetchingDeliveryDestinationsFilter() {
                this.getParams();
                // 納入先データ検索
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations_filter`,
                    this.$_requestConfig("params")
                ).then(response => {
                    // 現場名で昇順
                    this.listDeliveryDestinationsFilter = this.$_sorting(response.data, "delivery_destination_name");
                }).catch(() => {
                    this.$_modalError("fetchingDeliveryDestinationsFilterError");
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .is-wrap {
        min-width: 160px;
    }
</style>
